import React, {Component} from 'react';
import './header.style.scss';

class RarocHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {title, filter} = this.props;
    return (
      <div className='raroc-header-container'>
        <h1 className='raroc-header-title'>{title}</h1>
        <div>{filter}</div>
      </div>
    );
  }
}
export default RarocHeader;



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/Header/Header.js